
import React from 'react';
import { ConditionsTab } from '../organisms/node-settings/ConditionsTab';
import { EmailTemplateTab } from '../organisms/node-settings/EmailTemplateTab';
import { FormBuilderTab } from '../organisms/node-settings/FormBuilderTab';
import { AssignmentsTab } from '../organisms/node-settings/AssignmentsTab';
import { TimerTab } from '../organisms/node-settings/TimerTab';
import { MessageSignalTab } from '../organisms/node-settings/MessageSignalTab';
import { DatabaseTab } from '../organisms/node-settings/DatabaseTab';
import { CallActivityTab } from '../organisms/node-settings/CallActivityTab';
import { HttpTab } from '../organisms/node-settings/HttpTab';
import { ScriptTab } from '../organisms/node-settings/ScriptTab';
import { LLMConfigTab } from '../organisms/node-settings/LLMConfigTab';
import { UserTaskExtensionTab } from '../organisms/node-settings/UserTaskExtensionTab';
import { SmsTab } from '../organisms/node-settings/SmsTab';
import { ExtractionTab } from '../organisms/node-settings/ExtractionTab';
import { McpTab } from '../organisms/node-settings/McpTab';
import { DecisionTab } from '../organisms/node-settings/DecisionTab';
import { StartProcessTab } from '../organisms/node-settings/StartProcessTab';

// Default mapping of string keys to React Components
export const defaultComponentRegistry: Record<string, React.ComponentType<any>> = {
    'ConditionsTab': ConditionsTab,
    'RoutingTab': ConditionsTab, // Alias
    'EmailTemplateTab': EmailTemplateTab,
    'SmsTab': SmsTab,
    'FormBuilderTab': FormBuilderTab,
    'AssignmentsTab': AssignmentsTab,
    'TimerTab': TimerTab,
    'ScriptTab': ScriptTab,
    'MessageTab': (props: any) => React.createElement(MessageSignalTab, { ...props, type: "message" }),
    'MessageThrowTab': (props: any) => React.createElement(MessageSignalTab, { ...props, type: "message", isThrowing: true }),
    'SignalTab': (props: any) => React.createElement(MessageSignalTab, { ...props, type: "signal" }),
    'SignalThrowTab': (props: any) => React.createElement(MessageSignalTab, { ...props, type: "signal", isThrowing: true }),
    'DatabaseTab': DatabaseTab,
    'CallActivityTab': CallActivityTab,
    'RestConfigTab': HttpTab,
    'LLMConfigTab': LLMConfigTab,
    'UserTaskExtensionTab': UserTaskExtensionTab,
    'ExtractionTab': ExtractionTab,
    'McpConfigTab': McpTab,
    'DecisionConfigTab': DecisionTab,
    'StartProcessTab': StartProcessTab
};
